import { PATTERNS } from '@chat/shared';

/**
 * Assainissement des valeurs venant du serveur avant leur usage dans le DOM.
 *
 * Le serveur valide deja beaucoup, mais pas tout : `privacyPolicyUrl` n'est
 * controle qu'en longueur cote serveur (parseSiteConfig). Un
 * `javascript:alert(1)` place la par le back-office deviendrait executable des
 * qu'on l'affecterait a un href. On refuse donc tout schema autre que http(s),
 * ici, au dernier moment.
 */

const SAFE_SCHEMES = new Set(['http:', 'https:']);

/** `null` si l'URL est inexploitable ou porte un schema dangereux. */
export function safeHttpUrl(value: unknown): string | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (trimmed.length === 0 || trimmed.length > 2000) return null;

  try {
    const url = new URL(trimmed, window.location.href);
    return SAFE_SCHEMES.has(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
}

/**
 * Couleur hexadecimale, ou la valeur de repli.
 *
 * Une couleur non validee finirait dans une propriete CSS personnalisee ; meme si
 * setProperty n'evalue aucun script, une valeur libre permettrait d'y glisser une
 * declaration parasite.
 */
export function safeHexColor(value: unknown, fallback: string): string {
  return typeof value === 'string' && PATTERNS.hexColor.test(value.trim())
    ? value.trim()
    : fallback;
}

/**
 * Retire les caracteres de controle C0 et DEL.
 *
 * Ecrit par code de caractere plutot qu'avec une classe d'echappement : le
 * fichier reste lisible, sans sequence exotique susceptible d'etre abimee par un
 * outil de transformation.
 */
function stripControlChars(value: string): string {
  let out = '';
  for (const char of value) {
    const code = char.codePointAt(0);
    if (code !== undefined && code >= 0x20 && code !== 0x7f) out += char;
  }
  return out;
}

/**
 * Chaine bornee, sans caracteres de controle.
 *
 * Les caracteres de controle ne sont pas un vecteur d'injection ici -- tout est
 * rendu en textContent -- mais ils cassent l'affichage et la restitution vocale.
 *
 * A reserver aux libelles de configuration. NE PAS l'appliquer au corps d'un
 * message : les retours a la ligne voulus par l'auteur seraient perdus.
 */
export function safeText(value: unknown, maxLength: number, fallback = ''): string {
  if (typeof value !== 'string') return fallback;
  const cleaned = stripControlChars(value).trim();
  return cleaned.length === 0 ? fallback : cleaned.slice(0, maxLength);
}
